import { Form } from "components/Form/base/Form";
import { SubmitInput } from "components/Form/SubmitInput";
import { WYSIWYGInput } from "components/Form/WYSIWYGInput";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import React, { useState } from "react";
import { SpaceBooking } from "../types";

interface Props {
    booking: SpaceBooking;
    callback: (newBooking: SpaceBooking) => void;
}

export const SpaceBookingCancellationForm = ({ booking, callback = () => {} }: Props) => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `space/booking/${booking.id}/cancel`,
            method: "POST",
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback(data),
        });
    };

    const schema = Joi.object({
        message: Joi.string().allow("", null).max(10000).label("Nachricht"),
    }).unknown();

    return (
        <Form onSubmit={handleSubmit} validationSchema={schema}>
            <WYSIWYGInput name="message" label="Nachricht" />
            <SubmitInput isLoading={isLoading} variant="danger" block>
                Buchung stornieren
            </SubmitInput>
        </Form>
    );
};
